import { render, staticRenderFns } from "./LiveAgentAttachment.vue?vue&type=template&id=6f574998"
import script from "./LiveAgentAttachment.vue?vue&type=script&lang=ts"
export * from "./LiveAgentAttachment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports